
import { IStuLopNamHocActionTypes } from "../../action-types/category/IStuLopNamHocActions";
import { IStuLopNamHocReducer } from "../../reducer-model/category/IStuLopNamHocReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IStuLopNamHocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  lops: [],
  nam_hoc: ""
};
export const lopNamHocReduer = (
  state: IStuLopNamHocReducer = iniState,
  action: IStuLopNamHocActionTypes
): IStuLopNamHocReducer => {
  switch (action.type) {
    case "LOP_NAM_HOC_CHANGE_NAM_HOC":
      return {
        ...state,
        nam_hoc: action.payload,
        lops: [],
        status: eReducerStatusBase.is_need_reload
      };
    case "LOP_NAM_HOC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "LOP_NAM_HOC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        lops: action.payload,
      };
    case "LOP_NAM_HOC_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOP_NAM_HOC_REFRESH":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "LOP_NAM_HOC_UPDATE_CTDT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "LOP_NAM_HOC_UPDATE_CTDT_SUCCESS":
      let updates = [...state.lops];
      action.payload.forEach(u => {
        const idx = updates.findIndex(x => x.id_lop === u.id_lop)
        if (idx >= 0) {
          updates[idx] = {
            ...updates[idx],
            ...u
          }
        }
      })
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        lops: updates
      };
    case "LOP_NAM_HOC_UPDATE_CTDT_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
